import { Outlet } from "react-router-dom";
import { Layout, theme } from 'antd';

const { Content } = Layout;

const footerStyle = {
  textAlign: 'center',
  color: '#fff',
  backgroundColor: '#4096ff',
};

export default function LocalizationLayout() {
    const { token: { colorBgContainer, borderRadiusLG } } = theme.useToken();

    return (
        <Layout style={{ borderRadius: borderRadiusLG, margin: 0, padding: 0, background: colorBgContainer }} className="mx-auto min-h-[calc(100vh-64px)]">
            <Content style={{ borderRadius: borderRadiusLG, margin: 0, padding: 0, background: colorBgContainer }} className="w-full">
                <Outlet/>
            </Content>
            {/* <Footer className="w-full" style={footerStyle}>
                Footer
            </Footer> */}
        </Layout>
    );
}
